const earlyStopPhrases = [
	"i'm sorry",
	'i apologize',
	"couldn't find ",
	"couldn't generate",
	'provide more context',
	"don't have enough information",
];

export const isEarlyStopAnswerText = (text: string) => {
	const lowerCaseText = text.toLowerCase();
	return earlyStopPhrases.some((phrase) => lowerCaseText.includes(phrase));
};
